export default __webpack_public_path__ + "static/media/09AW1JAN66.24aa0d29.jpg";